import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as _ from 'lodash';
import { environment } from 'src/environments/environment';
import { interval, Subscription, Observable, of, throwError } from 'rxjs';
import { ICart } from '../../models/cart.interface';
import { AddSco, InitSco } from '../../store/actions/sco.actions';
import { Store, select } from '@ngrx/store';
import { IAppState } from '../../store/state/app.state';
import { DelScoSystem, AddScoSystem } from '../../store/actions/scosystem.actions';
import { MonitoringService } from '../utility/monitoring/monitoring.service';
import { ISco } from 'src/app/models/sco.interface';
import { map, catchError } from 'rxjs/operators';
import { IFreebet } from 'src/app/models/freebet.interface';
import { GetBalance } from 'src/app/store/actions/balance.actions';
import {
  PageSetFreebetSingle,
  PageSetFreebetMultiple,
  PageSetFreebetSystem,
  PageSetBonusSingle,
  PageSetBonusMultiple,
  PageSetBonusSystem,
} from 'src/app/store/actions/page.actions';
import { IBonus } from 'src/app/models/bonus.interface';
import {selectFunctionCompleteBet, selectTerminalTag} from 'src/app/store/selectors/page.selectors';
import { selectFunctionButtonBet } from 'src/app/store/selectors/page.selectors';
import { DeviceDetectorService } from 'ngx-device-detector';
import { BonusPipe } from 'src/app/pipe/bonus.pipe';
import { TotSelect, CartTot, Sco, ScoPsr } from 'src/app/models/totselect.interface';
import { IStateCart } from 'src/app/models/statecart.interface';
import {IIdentify} from '../../models/identify.interface';
import {IdentifyService} from '../http/identify/identify.service';
import {UrlControllerService} from '../url-controller.service';
import {GoogleAnalyticsService} from '../analytics/google-analytics.service';
import sortBy from 'lodash/sortBy';
import {PostmessageService} from '../utility/sendmessage/postmessage.service';
import {groupBy} from 'lodash';

const enum DeviceType {
  DesktopAndroidUnix = 110,
  DesktopIos = 111,
  DesktopWindows = 112,
  DesktopAltro = 114,
  MobileAndroidUnix = 130,
  MobileIos = 131,
  MobileWindows = 132,
  MobileAltro = 134,
}

@Injectable({
  providedIn: 'root',
})
export class CartService extends UrlControllerService {
  // private apiUrlFixed = this.apiUrlSelected + 'rest/online/fixed';
  // private apiUrlTot = this.apiUrlSelected + 'rest/online/';


  /**
   * Flag per i sistemi a combinazione
   * */

  public sistema = false;

  /**
   * Flag per le multiple
   * */

  public multiple = false;

  /**
   * Valore quota tot sistema
   */
  private _qmMax: number;

  /**
   * Valore quota tot sistema
   */
  private _qmMin: number;

  /**
   * Loading pulsante bet
   */
  public loadBet = false;

  /**
   * Valore ritorno giocata da mostrare
   */
  public idTicket: string;

  public esi: number;

  /**
   * Messaggio di ritorno da mostrare nel carrello
   */
  public desMessage: string;

  public changeAmount = 0;
  /**
   * Puntata base sistema
   */
  public puntataBaseSistema: number;

  /**
   * Puntata base sistema bonus
   */
  public puntataBaseSistemaBonus: number;


  /**
   * Flag se messaggio risposta cambio quota
   */
  public changeOdds = false;

  /**
   * Flag se messaggio risposta è un esito diverso da 1024 e non rietra tra gli errori
   */
  public otherEsi = false;

  /**
   * QuotaTotale giocata classica
   */
  public totalOdd: number;

  public session: string;

  public combination: number;

  public quotaTotale = 1;

  /**
   * Bonus al standard
   */

  public bonusStandard = [1 , 3];

  /**
   * Bonus al Netto
   *
   */

  public bonusNetto = [2 , 4];

  public cartBase: ICart = {
    pun: 100,
    pag: 0,
    ig: 0,
    ses: '',
    sezione: 'home',
    bonus: 0,
    tp: 0, // sistemi 2
    tg: 0,
    sco: [],
    id_bonus: '',
    accept: 0
  };

  public cartBaseSistemi: ICart = {
    pun: 100,
    pag: 0,
    ig: 0,
    ses: '',
    sezione: 'home',
    bonus: 0,
    tp: 0, // sistemi 2
    tg: 0,
    sco: [],
    id_bonus: '',
    accept: 0,
    avv: [], //sistemi
    sis: [], // sistemi
    comb: [],
    pagMax: 0,
    pagmin: 0,
  };

  public cartSystem: ICart = {
    pun: 100,
    pag: 0,
    ig: 0,
    ses: '',
    sezione: 'home',
    bonus: 0,
    tp: 1,
    tg: 0,
    sco: [],
    id_bonus: '',
    accept: 0
  };

  public baseFreebet: IFreebet = {
    id: '',
    stake: 0,
    valid_from: '',
    valid_until: '',
    name: '',
    speciality: '',
    sigla: '',
    id_meeting: '0',
    id_race: '0',
    min_odd: 0,
    max_odd: 0,
    s_min: 0,
    s_max: 0,
    net_payout: 0,
    type: 0,
  };

  public functionCompleteBet = '';

  public functionCompleteBet$: Observable<string>;
  public terminalTag$: Observable<number>;

  readonly FREEBETBASE: IFreebet = {
    id: '',
    stake: 0,
    valid_from: '',
    valid_until: '',
    name: '',
    speciality: '',
    sigla: '',
    id_meeting: '0',
    id_race: '0',
    min_odd: 0,
    max_odd: 0,
    s_min: 0,
    s_max: 0,
    net_payout: 0,
    type: 0,
  };

  bonus: IBonus[];

  bonusSingleFlag = false;

  tipoGicata: number;

  error: any;

  oldSco: any;

  oldPag: any;

  constructor(
      private http: HttpClient,
      private appInsightsService: MonitoringService,
      public _store: Store<IAppState>,
      private deviceService: DeviceDetectorService,
      private bonusPipe: BonusPipe,
      public googleAnalyticsService: GoogleAnalyticsService,
      private postmessage: PostmessageService
  ) {
    super(_store);
    this.functionCompleteBet$ = this._store.pipe(select(selectFunctionCompleteBet));
    this.terminalTag$ = this._store.pipe(select(selectTerminalTag));
    this.functionCompleteBet$.subscribe((x) => (this.functionCompleteBet = x));
    this.tipoGicata = this.getDeviceType();
    this.cartBase.tg = this.tipoGicata;
    this.cartSystem.tg = this.tipoGicata;
    this.terminalTag$.subscribe((x) => {
      if (x !== 0) {
        this.tipoGicata = x;
        this.cartBase.tg = this.tipoGicata;
        this.cartSystem.tg = this.tipoGicata;
      }
    });
  }

  getDeviceType(): number {
    const deviceInfo = this.deviceService.getDeviceInfo();
    if (this.deviceService.isDesktop()) {
      switch (deviceInfo.os.toUpperCase()) {
        case 'WINDOWS':
        case 'WINDOWS_PHONE': {
          return DeviceType.DesktopWindows;
        }
        case 'MAC':
        case 'IOS': {
          return DeviceType.DesktopIos;
        }
        case 'ANDROID':
        case 'LINUX':
        case 'UNIX':
        case 'FIREFOX_OS':
        case 'CHROME_OS': {
          return DeviceType.DesktopAndroidUnix;
        }
        case 'UNKNOWN': {
          return DeviceType.DesktopAltro;
        }
        default: {
          return DeviceType.DesktopAltro;
        }
      }
    } else {
      switch (deviceInfo.os.toUpperCase()) {
        case 'WINDOWS':
        case 'WINDOWS_PHONE': {
          return DeviceType.MobileWindows;
        }
        case 'MAC':
        case 'IOS': {
          return DeviceType.MobileIos;
        }
        case 'ANDROID':
        case 'LINUX':
        case 'UNIX':
        case 'FIREFOX_OS':
        case 'CHROME_OS': {
          return DeviceType.MobileAndroidUnix;
        }
        case 'UNKNOWN': {
          return DeviceType.MobileAltro;
        }
        default: {
          return DeviceType.MobileAltro;
        }
      }
    }
  }

  get qmMax(): any {
    return this._qmMax;
  }

  set qmMax(qmMax: any) {
    this._qmMax = qmMax;
  }

  get qmMin(): any {
    return this._qmMin;
  }

  set qmMin(qmMin: any) {
    this._qmMin = qmMin;
  }

  /*
  *  Function to use for multiple and system bet (Acc e Trio)
  * */
  placeBet(system: boolean, bonus?) {
    this.oldPag = null;
    this.oldSco = null;

    if (system) {
      // Analytic Service Event click bet
      this.cartSystem.sco.forEach((s) => {
        this.googleAnalyticsService.eventClickBet(s);
      });
    }

    this.cartSystem.sco.map((x) => {
      delete x['error'];
    });
    this.cartBase.sco.map((x) => {
      delete x['error'];
    });

    this.loadBet = true;
    let sendObj: any;
    if (system) {
      sendObj = _.cloneDeep(this.cartSystem);
      sendObj.sco.map((x) => {
        delete x['extra'];
        delete x['comb'];
        // sendObj.accept = 1;
      });
    } else {
      sendObj = _.cloneDeep(this.cartBase);
      sendObj.sco.map((x) => {
        delete x['extra'];
      });
    }

    if (sendObj.bonus === 0 && bonus) {
      sendObj.bonus = Number(this.bonus[0].type);
    }

    if (
        (this.bonus && this.bonus.length > 0 && this.bonus[0].type && this.bonusNetto.includes(Number(this.bonus[0].type))) ||
        (this.baseFreebet.type && this.bonusNetto.includes(Number(this.baseFreebet.type)))
    ) {
      sendObj.pag = sendObj.pag - sendObj.pun;
    }

    const prop = {
      pun: sendObj.pun,
      pag: sendObj.pag,
      ses: sendObj.ses,
      ig: sendObj.ig,
    };
    this.appInsightsService.logEvent('PlaceBet', prop);


    this.http.post<any>(this.apiUrlSelected + 'rest/online/fixed', sendObj).subscribe((data) => {
          if (data.Esi && data.Des) {
            this.esi = data.Esi;
            this.desMessage = data.Des;
          }
          if (data.Esi === 1024) {
            this.changeOdds = false;
            this.otherEsi = false;
            this.loadBet = false;
            this.oldSco = null;
            this.oldPag = null;
            this.idTicket = data.Id;
            this.changeAmount = 0;
            this.postmessage.sendPostMessage({func: this.functionCompleteBet});
            // window.parent.postMessage(
            //   {
            //     func: this.functionCompleteBet,
            //   },
            //   '*'
            // );
            this.appInsightsService.logEvent('OkBet', data);
            if (this.cartBase.ses && this.cartBase.ses !== '' && this.cartBase.ses !== 'null') {
              this._store.dispatch(new GetBalance(this.cartBase.ses));
            }
            this._store.dispatch(new PageSetFreebetSingle(this.FREEBETBASE));
            this._store.dispatch(new PageSetFreebetMultiple(this.FREEBETBASE));
            this._store.dispatch(new PageSetFreebetSystem(this.FREEBETBASE));
            this._store.dispatch(new PageSetBonusSingle(false));
            this._store.dispatch(new PageSetBonusMultiple(false));
            this._store.dispatch(new PageSetBonusSystem(false));
          }

          if ( data.Esi === 502) {
            data.Comb = sortBy(data.Comb, 'P1', 'P2', 'P3');
            this.cartSystem.sco[0].comb = sortBy(this.cartSystem.sco[0].comb, 'combin.0.c', 'combin.1.c', 'combin.2.c');
            data.Comb.forEach((comb, index) => {
              this.cartSystem.sco[0].comb[index].qm = comb.Odd;
            });
            this.oldPag = this.cartSystem.pag;
            this.cartSystem.pag = data.Pag;
            // console.log(data.Comb);
            // console.log(win);
            // console.log(Math.max(...win));
          }

          if (data.Err && data.Err.length > 0 ) {
            data.Err.forEach((x) => {
              if ( x.Esi === 302) {
                this.changeOdds = true;
                this.otherEsi = false;
                this.loadBet = false;
                this.changeAmount = 0;
                this.oldSco = JSON.parse(JSON.stringify(this.cartBase.sco));
                this.oldPag = this.cartSystem.pag;
                if (!system) {
                  const scoMod = this.cartBase.sco.filter(
                      (y) => y.race === String(x.Race) && y.esi === String(x.Eve)
                  );
                  scoMod[0].quo = x.Quo;
                  this.oldPag = this.cartBase.pag;
                  this._store.dispatch(new AddSco(scoMod[0]));
                } else {
                  let lavagna = 0;
                  let stringLavagna;
                  data.Err.forEach((element) => {
                    if (element.Esi === 302 && element.Quo !== 0) {
                      lavagna = lavagna + 100 / element.Quo;
                    }
                    // console.log(lavagna);
                  });
                  stringLavagna = (lavagna * 100).toFixed(2);
                  this.cartSystem.sco[0].lav = (stringLavagna * 100).toFixed(2);
                  switch (this.cartSystem.sco[0].cod) {
                    case 7: {
                      this.cartSystem.sco[0].map[0].e.map((y) => {
                        const quote = data.Err.filter((z) => z.Eve === y.c);
                        if (quote.length === 1) {
                          y.q = quote[0].Quo;
                        }
                        return y;
                      });
                      this.cartSystem.sco[0].comb = this.calcolaQuinella(
                          Number(stringLavagna),
                          Number((data.Lavagna / 100).toFixed(2)),
                          this.cartSystem.sco[0].map[0].e,
                          data.Np
                      );
                      break;
                    }
                    case 9: {
                      this.cartSystem.sco[0].map[0].e.map((y) => {
                        const quote = data.Err.filter((z) => z.Eve === y.c);
                        if (quote.length === 1) {
                          y.q = quote[0].Quo;
                        }
                        return y;
                      });
                      this.cartSystem.sco[0].comb = this.calcolaTrio(
                          Number(stringLavagna),
                          Number((data.Lavagna / 100).toFixed(2)),
                          this.cartSystem.sco[0].map[0].e,
                          data.Np
                      );
                      break;
                    }
                    case 8: {
                      this.cartSystem.sco[0].map[0].e.map((y) => {
                        const quote = data.Err.filter((z) => z.Eve === y.c);
                        if (quote.length === 1) {
                          y.q = quote[0].Quo;
                        }
                        return y;
                      });
                      this.cartSystem.sco[0].map[1].e.map((y) => {
                        const test = data.Err.filter((z) => z.Eve === y.c);
                        if (test.length === 1) {
                          y.q = test[0].Quo;
                        }
                        return y;
                      });
                      this.cartSystem.sco[0].comb = this.calcolaExacta(
                          Number(stringLavagna),
                          Number((data.Lavagna / 100).toFixed(2)),
                          [this.cartSystem.sco[0].map[0].e, this.cartSystem.sco[0].map[1].e],
                          data.Np
                      );
                      break;
                    }
                    case 10: {
                      this.cartSystem.sco[0].map[0].e.map((y) => {
                        const quote = data.Err.filter((z) => z.Eve === y.c);
                        if (quote.length === 1) {
                          y.q = quote[0].Quo;
                        }
                        return y;
                      });
                      this.cartSystem.sco[0].map[1].e.map((y) => {
                        const test = data.Err.filter((z) => z.Eve === y.c);
                        if (test.length === 1) {
                          y.q = test[0].Quo;
                        }
                        return y;
                      });
                      this.cartSystem.sco[0].map[2].e.map((y) => {
                        const test = data.Err.filter((z) => z.Eve === y.c);
                        if (test.length === 1) {
                          y.q = test[0].Quo;
                        }
                        return y;
                      });
                      this.cartSystem.sco[0].comb = this.calcolaTricast(
                          Number(stringLavagna),
                          Number((data.Lavagna / 100).toFixed(2)),
                          [
                            this.cartSystem.sco[0].map[0].e,
                            this.cartSystem.sco[0].map[1].e,
                            this.cartSystem.sco[0].map[2].e,
                          ],
                          data.Np
                      );
                      break;
                    }
                  }
                  this._store.dispatch(new AddScoSystem(this.cartSystem.sco[0]));
                }
              } else {
                this.changeOdds = false;
                this.otherEsi = false;
                this.loadBet = false;
                if (x.Max > 0) {
                  this.changeAmoutMultiple(x.Max / 100);
                  this.changeAmount = x.Max / 100;
                } else {
                  this.changeAmount = 0;
                }
                this.appInsightsService.logEvent('ErrorBet', x);
                if (this.cartBase.ses && this.cartBase.ses !== '' && this.cartBase.ses !== 'null') {
                  this._store.dispatch(new GetBalance(this.cartBase.ses));
                }
                this._store.dispatch(new PageSetFreebetSingle(this.FREEBETBASE));
                this._store.dispatch(new PageSetFreebetMultiple(this.FREEBETBASE));
                this._store.dispatch(new PageSetFreebetSystem(this.FREEBETBASE));
                this._store.dispatch(new PageSetBonusSingle(false));
                this._store.dispatch(new PageSetBonusMultiple(false));
                this._store.dispatch(new PageSetBonusSystem(false));
              }
              this.cartBase.sco.forEach((s) => {
                s.error = String(x.Race) === s.race ? x : s.error;
              });
            });
          } else if (data.Esi !== 1024) {
            this.changeOdds = false;
            this.otherEsi = true;
            this.loadBet = false;
            if (data.Max > 0) {
              this.changeAmoutMultiple(data.Max / 100);
              this.changeAmount = data.Max / 100;
            } else {
              this.changeAmount = 0;
            }
            this.appInsightsService.logEvent('ErrorBet', data);
            if (this.cartBase.ses && this.cartBase.ses !== '' && this.cartBase.ses !== 'null') {
              this._store.dispatch(new GetBalance(this.cartBase.ses));
            }
            this._store.dispatch(new PageSetFreebetSingle(this.FREEBETBASE));
            this._store.dispatch(new PageSetFreebetMultiple(this.FREEBETBASE));
            this._store.dispatch(new PageSetFreebetSystem(this.FREEBETBASE));
            this._store.dispatch(new PageSetBonusSingle(false));
            this._store.dispatch(new PageSetBonusMultiple(false));
            this._store.dispatch(new PageSetBonusSystem(false));
          }
        },
        (error) => {
          if (error) {
            this.esi = 3;
            this.loadBet = false;
          }
        });
  }

  /*
  *  Function to use for sistemi bet
  * */
  placeBetSistemi(bonus?) {
    this.oldPag = null;
    this.oldSco = null;
    this.loadBet = true;

    this.cartBaseSistemi.sco.map((x) => {
      delete x['error'];
    });

    const sendObj = _.cloneDeep(this.cartBaseSistemi);
    sendObj.pun = 0;
    sendObj.sis = sendObj.sis.filter((s) => Number(s.imp) !== 0);
    sendObj.sis.forEach((s) => {
      sendObj.pun = sendObj.pun + ((s.imp * s.mul) * 100);
      s.imp = s.imp * 100;
    });
    sendObj.pag = Math.round(sendObj.pag * 100);
    sendObj.tp = 2;
    delete sendObj['comb'];
    delete sendObj['sco'];

    this.http.post<any>(this.apiUrlSelected + 'rest/online/fixed', sendObj).subscribe((data) => {
          if (data.Esi && data.Des) {
            this.esi = data.Esi;
            this.desMessage = data.Des;
          }
          if (data.Esi === 1024) {
            this.changeOdds = false;
            this.otherEsi = false;
            this.loadBet = false;
            this.oldSco = null;
            this.oldPag = null;
            this.idTicket = data.Id;
            this.changeAmount = 0;
            this.postmessage.sendPostMessage({func: this.functionCompleteBet});
            this.appInsightsService.logEvent('OkBet', data);
            if (this.cartBaseSistemi.ses && this.cartBaseSistemi.ses !== '' && this.cartBaseSistemi.ses !== 'null') {
              this._store.dispatch(new GetBalance(this.cartBaseSistemi.ses));
            }
            this._store.dispatch(new PageSetFreebetSingle(this.FREEBETBASE));
            this._store.dispatch(new PageSetFreebetMultiple(this.FREEBETBASE));
            this._store.dispatch(new PageSetFreebetSystem(this.FREEBETBASE));
            this._store.dispatch(new PageSetBonusSingle(false));
            this._store.dispatch(new PageSetBonusMultiple(false));
            this._store.dispatch(new PageSetBonusSystem(false));
          }

          if ( data.Esi === 502 && data.Sys.length > 0) {
            data.Sys.forEach((sis) => {
              this.cartBaseSistemi.comb.pag[sis.Cod] = [Number(sis.Win) / 100];
              this.cartBaseSistemi.comb.pagMin[sis.Cod] = [Number(sis.MinWin) / 100];
            });
            this.getSummary();
          }

          if (data.Err && data.Err.length > 0 ) {
            data.Err.forEach((x) => {
              if ( x.Esi === 302) {
                this.changeOdds = true;
                this.otherEsi = false;
                this.loadBet = false;
                this.changeAmount = 0;
                if (this.oldSco === null) {
                  this.oldSco = JSON.parse(JSON.stringify(this.cartBaseSistemi.sco));
                }
                this.oldPag = this.cartBaseSistemi.pag;
                const scoMod = this.cartBaseSistemi.sco.filter(
                    (y) => y.race === String(x.Race) && y.esi === String(x.Eve) && y.cod === Number(x.Sco)
                );
                scoMod[0].quo = x.Quo;
                this._store.dispatch(new AddSco(scoMod[0]));
              } else {
                this.changeOdds = false;
                this.otherEsi = false;
                this.loadBet = false;
                /* todo questo serve adesso nei sistemi */
                // if (x.Max > 0) {
                //   this.changeAmoutMultiple(x.Max / 100);
                //   this.changeAmount = x.Max / 100;
                // } else {
                //   this.changeAmount = 0;
                // }
                /* fine */
                this.appInsightsService.logEvent('ErrorBet', x);
                if (this.cartBase.ses && this.cartBase.ses !== '' && this.cartBase.ses !== 'null') {
                  this._store.dispatch(new GetBalance(this.cartBase.ses));
                }
                this._store.dispatch(new PageSetFreebetSingle(this.FREEBETBASE));
                this._store.dispatch(new PageSetFreebetMultiple(this.FREEBETBASE));
                this._store.dispatch(new PageSetFreebetSystem(this.FREEBETBASE));
                this._store.dispatch(new PageSetBonusSingle(false));
                this._store.dispatch(new PageSetBonusMultiple(false));
                this._store.dispatch(new PageSetBonusSystem(false));
              }
              this.cartBaseSistemi.sco.forEach((s) => {
                s.error = String(x.Race) === s.race ? x : s.error;
              });
            });
          } else if (data.Esi !== 1024) {
            this.changeOdds = false;
            this.otherEsi = true;
            this.loadBet = false;
            if (data.Max > 0) {
              this.changeAmoutMultiple(data.Max / 100);
              this.changeAmount = data.Max / 100;
            } else {
              this.changeAmount = 0;
            }
            this.appInsightsService.logEvent('ErrorBet', data);
            if (this.cartBase.ses && this.cartBase.ses !== '' && this.cartBase.ses !== 'null') {
              this._store.dispatch(new GetBalance(this.cartBase.ses));
            }
            this._store.dispatch(new PageSetFreebetSingle(this.FREEBETBASE));
            this._store.dispatch(new PageSetFreebetMultiple(this.FREEBETBASE));
            this._store.dispatch(new PageSetFreebetSystem(this.FREEBETBASE));
            this._store.dispatch(new PageSetBonusSingle(false));
            this._store.dispatch(new PageSetBonusMultiple(false));
            this._store.dispatch(new PageSetBonusSystem(false));
          }
        },
        (error) => {
          if (error) {
            this.esi = 3;
            this.loadBet = false;
          }
        });
  }

  /*
  *  Function to use for single bet
  * */
  placeBetSingle(sco: ISco): Observable<ISco> {
    let sendObj: ICart;

    sendObj = {
      pun: sco.extra.amount * 100,
      pag: Math.round(sco.extra.amount * 100 * (Number(sco.quo) / 100)),
      ig: 0,
      ses: this.session,
      sezione: 'home',
      bonus: this.bonusSingleFlag ? this.bonus[0].type : this.baseFreebet.type,
      tp: 0,
      tg: this.tipoGicata,
      id_bonus: this.baseFreebet.id,
      accept: sco.accept,
      sco: [
        {
          race: sco.race,
          cod: sco.cod,
          esi: sco.esi,
          quo: sco.quo,
          oldQuo: '',
          ia: sco.ia,
        },
      ],
    };

    if (
        (this.bonusSingleFlag && this.bonus && this.bonus.length > 0 && this.bonus[0].type && this.bonusNetto.includes(Number(this.bonus[0].type))) ||
        (!this.bonusSingleFlag && this.bonusNetto.includes(Number(this.baseFreebet.type)))
    ) {
      sendObj.pag = sendObj.pag - sendObj.pun;
    }

    const prop = {
      pun: sendObj.pun,
      pag: sendObj.pag,
      ses: sendObj.ses,
      ig: sendObj.ig,
    };

    this.appInsightsService.logEvent('PlaceBetSingle', prop);

    // Analytic Service Event click bet
    this.googleAnalyticsService.eventClickBet(sco);

    return this.http.post<any>(this.apiUrlSelected + 'rest/online/fixed', sendObj).pipe(
        map((result) => {
          if (result && result.Esi) {
            sco.oldQuo = null;
            sco.state.esi = result.Esi;
            sco.state.idTicket = result.Id;
            sco.state.description = result.Des;
            sco.extra.max = 0;
            this.appInsightsService.logEvent('OkBetSingle', result);
            if (result.Esi === 302) {
              sco.oldQuo = sco.quo;
              sco.quo = result.Quo;
            }
            if (result.Esi === 1024) {
              this.postmessage.sendPostMessage({func: this.functionCompleteBet});
              this._store.dispatch(new GetBalance(this.cartBase.ses));
              if (result.Err && result.Err.length > 0) {
                // Faccio un for ma in realtà mi aspetto un solo valore
                result.Err.forEach((x) => {
                  if ( x.Esi === 302) {
                    sco.oldQuo = sco.quo;
                    sco.quo = x.Quo;
                  }
                });
              }
            }
            if (result.Max > 0) {
              sco.extra.max = result.Max / 100;
              sco.extra.amount = result.Max / 100;
            }
          } else {
            throw new Error('No results');
          }
          return sco;
        }),
        catchError(
            this.appInsightsService.handleError<ISco>('PlaceBetSingle', {
              ...sco,
              state: {
                esi: 3,
                idTicket: null,
                description: 'Problem sending data',
              },
            })
        )
    );
  }

  /*
  *  Function to use for tote bet
  * */
  placeScoTot(scoTot: TotSelect): Observable<TotSelect> {
    const arrayTot: Sco[] = [...scoTot.scoTot];
    const arrayPsr: ScoPsr[] = [...scoTot.scoPsr];

    if (scoTot.combinazioni > 0) {
      const array = [];
      for (let _i = 0; _i < scoTot.sisSel.map; _i++) {
        array[_i] = { esi: scoTot.maps[_i] };
      }
      if (scoTot.scoSel.tipo === 'TOT') {
        const sco: Sco = {
          cod: scoTot.scoSel.value.toString(),
          sis: scoTot.sisSel.value.toString(),
          mol: scoTot.multi.toString(),
          imp: scoTot.total,
          map: array,
        };
        arrayTot.push(sco);
      } else {
        const scoPsr: ScoPsr = {
          uni: scoTot.combinazioni,
          mol: scoTot.multi.toString(),
          imp: scoTot.total,
          gru: [
            {
              cod: 1,
              eve: [
                {
                  cod: scoTot.concPsr,
                  sco: scoTot.scoSel.value.toString(),
                  sis: scoTot.sisSel.value.toString(),
                  map: array,
                },
              ],
            },
          ],
        };
        arrayPsr.push(scoPsr);
      }
    }

    let sendObj;
    let apiUrl;

    if (arrayTot.length > 0) {
      apiUrl = this.apiUrlSelected + 'rest/online/tot';

      sendObj = {
        ses: scoTot.session,
        sezione: 'tot',
        tg: this.tipoGicata,
        bonus: 0,
        ig: new Date().getTime() - new Date().setHours(0, 0, 0, 0),
        pal: scoTot.pal.toString(),
        avv: scoTot.avv.toString(),
        race: scoTot.race.toString(),
        pun: scoTot.totalTicket,
        sco: arrayTot,
      };
    } else {
      if (Number(scoTot.concPsr) > 0 && Number(scoTot.palPsr) > 0) {
        apiUrl = this.apiUrlSelected + 'rest/online/psr';
        sendObj = {
          ses: scoTot.session,
          sezione: 'psr',
          bonus: 0,
          tg: this.tipoGicata,
          ig: new Date().getTime() - new Date().setHours(0, 0, 0, 0),
          tip: 1,
          tc: scoTot.tcPsr,
          car: 0,
          nc: 0,
          pal: scoTot.palPsr,
          con: scoTot.concPsr,
          race: scoTot.race.toString(),
          pun: scoTot.totalTicket,
          sco: arrayPsr,
        };
      } else {
        scoTot.state.esi = 90000;
        scoTot.state.idTicket = null;
        scoTot.state.description = 'Tipo di giocata non conforme';
        return of(scoTot);
      }
    }

    const prop = {
      pun: sendObj.pun,
      ses: sendObj.ses,
    };

    this.appInsightsService.logEvent('PlaceBetTot', prop);

    return this.http.post<any>(apiUrl, sendObj).pipe(
        map((result) => {
          if (result && result.Esi) {
            scoTot.state.esi = result.Esi;
            scoTot.state.idTicket = result.Id;
            scoTot.state.description = result.Des;

            this.appInsightsService.logEvent('OkBetTot', result);
            if (result.Esi === 1024) {
              this.postmessage.sendPostMessage({func: this.functionCompleteBet});
              // window.parent.postMessage(
              //     {
              //       func: this.functionCompleteBet,
              //     },
              //     '*'
              // );
            }
          } else {
            throw new Error('No results');
          }
          return scoTot;
        }),
        catchError(
            this.appInsightsService.handleError<TotSelect>('PlaceBetTot', {
              ...scoTot,
              state: {
                esi: 3,
                idTicket: null,
                description: 'Problem sending data',
              },
            })
        )
    );
  }

  /*
  *  Function to use for tote to quick button bet
  * */
  placeScoTotQuick(sco: any): Observable<IStateCart> {
    let sendObj;
    let apiUrl;

    if (sco.isTot) {
      apiUrl = this.apiUrlSelected + 'rest/online/tot';

      sendObj = {
        ses: sco.ses,
        sezione: 'tot',
        tg: this.tipoGicata,
        bonus: 0,
        ig: new Date().getTime() - new Date().setHours(0, 0, 0, 0),
        pal: sco.pal,
        avv: sco.avv,
        pun: sco.pun,
        sco: sco.sco,
        race: sco.race.toString(),
      };
    } else {
      apiUrl = this.apiUrlSelected + 'rest/online/psr';
      sendObj = {
        ses: sco.ses,
        sezione: 'psr',
        bonus: 0,
        tg: this.tipoGicata,
        ig: new Date().getTime() - new Date().setHours(0, 0, 0, 0),
        tip: 1,
        tc: sco.tc,
        car: 0,
        nc: 0,
        pal: sco.pal,
        con: sco.conc,
        pun: sco.pun,
        sco: sco.sco,
        race: sco.race.toString(),
      };
    }

    return this.http.post<any>(apiUrl, sendObj).pipe(
        map((result) => {
          const res: IStateCart = {
            esi: result.Esi,
            idTicket: result.Id,
            description: result.Des,
          };
          if (result.Esi === 1024) {
            this.postmessage.sendPostMessage({func: this.functionCompleteBet});
            // window.parent.postMessage(
            //     {
            //       func: this.functionCompleteBet,
            //     },
            //     '*'
            // );
          }
          return res;
        }),
        catchError(
            this.appInsightsService.handleError<IStateCart>('PlaceQuickBetTot', {
              esi: 3,
              idTicket: null,
              description: 'Problem sending data',
            })
        )
    );
  }

  resetCart(system: boolean, identify: IIdentify) {
    this.idTicket = null;
    this.esi = null;
    this.oldSco = null;
    this.oldPag = null;
    this.changeOdds = false;
    this.otherEsi = false;

    if (!system) {
      // this._store.dispatch(new InitSco());
      this.cartBase.pun = Number(identify.def_stake);
      this.cartBase.pag = 0;
      (this.cartBase.ig = 0), (this.cartBase.tp = 0), (this.cartBase.sco = []);
      this.cartBaseSistemi.avv = [];
      this.cartBaseSistemi.sis = [];
      this.cartBaseSistemi.comb = [];
    } else {
      this._store.dispatch(new DelScoSystem());
      this.cartSystem.pun = Number(identify.def_stake_sys);
      this.cartSystem.pag = 0;
      (this.cartSystem.ig = 0), (this.cartSystem.tp = 1), (this.cartSystem.sco = []);
    }
  }

  resetEsi() {
    this.esi = null;
    this.oldSco = null;
    this.oldPag = null;
    this.changeOdds = false;
    this.otherEsi = false;
    this.idTicket = null;
  }

  resetCountdown() {
    if ( this.esi !== 1024 ) {
      this.idTicket = null;
    }
  }

  changeAmoutMultiple(amount: number) {
    if (amount && amount > 0) {
      this.cartBase.pun = Math.round(amount * 100);
      this.cartBase.pag = Math.floor(Number(this.quotaTotale * this.cartBase.pun));
      if (
          this.bonus &&
          !this.bonusPipe.transform(
              this.bonus,
              this.cartBase.sco,
              'multiple',
              this.totalOdd,
              this.cartBase.pun
          )
      ) {
        this._store.dispatch(new PageSetBonusMultiple(false));
      }
    }
  }

  ConvertStringToNumber(input: string): number {
    return Number(input);
  }

  numberOnly(event): boolean {
    if (isNaN(Number(event.key))) {
      return false;
    }
    return true;

  }

  notZero(event) {
    event.target.value = event.target.value.replace(/^0+/, '');
  }

  numberAndDotOnly(event): void {
    const inputElement = event.target as HTMLInputElement;
    let value = inputElement.value;

    // Sostituisci la virgola con un punto
    value = value.replace(',', '.');

    // Consenti solo numeri e il punto decimale
    if (!/^[0-9]*\.?[0-9]*$/.test(value)) {
      value = value.replace(/[^0-9.]/g, '');
    }

    // Verifica se il numero è maggiore di 0.1
    // if (parseFloat(value) <= 0.1) {
    //   value = '';
    // }

    // Aggiorna il valore dell'input
    inputElement.value = value;
  }


  totalAmount(data: ISco[]): number {
    let total = 0;
    data.forEach((element) => {
      total = total + element.extra.amount;
    });
    return total;
  }

  calcolaQuinella(lavagna: number, lavagnaSend: number, items: any[], npartenti): any[] {
    // console.log('lavagna'+ lavagna);
    // console.log('lavagna2' + lavagnaSend);
    // console.log('imens' + items);
    // console.log(npartenti);

    const combin = this.binomialCombination(items, 2);
    return combin.map((x) => {
      x.qm = this.calcola_qm_quinella(x.combin, lavagna, lavagnaSend, npartenti);
      if (x.qm  > 0 && x.qm < 105) {
        x.qm = 105;
      }
      return x;
    });
  }

  calcolaTrio(lavagna: number, lavagnaSend: number, items: any[], npartenti): any[] {
    const combin = this.binomialCombination(items, 3);

    return combin.map((x) => {
      x.qm = this.calcola_qm_trio(x.combin, lavagna, lavagnaSend, npartenti);
      if (x.qm  > 0 && x.qm < 105) {
        x.qm = 105;
      }
      return x;
    });
  }

  calcolaTricast(lavagna: number, lavagnaSend: number, items: any[], npartenti): any[] {
    const combin = this.cartesianProduct(items);

    return combin.map((x) => {
      x.qm = this.quotaVera(this.calcola_q_tricast(x.combin, lavagna, lavagnaSend), lavagnaSend, npartenti );
      return x;
    });
  }

  calcolaExacta(lavagna: number, lavagnaSend: number, items: any[], npartenti) {
    const combin = this.cartesianProduct(items);

    // console.log(lavagna);
    // console.log(lavagnaSend);
    // console.log(items);
    // console.log(npartenti);

    return combin.map((x) => {
      x.qm = this.quotaVera(this.calcola_q_exacta(x.combin, lavagna, lavagnaSend), lavagnaSend, npartenti );
      return x;
    });
  }

  private binomialCombination(items: any[], numSubItems: number): any[] {
    const combin = [];
    const indexes = new Array(numSubItems);
    for (let i = 0; i < numSubItems; i++) {
      indexes[i] = i;
    }
    while (indexes[0] < items.length - numSubItems + 1) {
      const v = { qm: null, combin: [] };
      for (let i = 0; i < numSubItems; i++) {
        v.combin.push(items[indexes[i]]);
      }
      combin.push(v);
      indexes[numSubItems - 1]++;
      let l = numSubItems - 1; // reference always is the last position at beginning
      while (
          indexes[numSubItems - 1] >= items.length &&
          indexes[0] < items.length - numSubItems + 1
          ) {
        l--; // the last position is reached
        indexes[l]++;
        for (let i = l + 1; i < numSubItems; i++) {
          indexes[i] = indexes[l] + (i - l);
        }
      }
    }
    return combin;
  }

  private cartesianProduct(arr: any): any[] {
    const cartesian = arr.reduce(
        (a, b) =>
            a
                .map((x) =>
                    b.map((y) => {
                      if (x) {
                        if (x.some((v) => v.c === y.c)) {
                          return;
                        } else {
                          return x.concat(y);
                        }
                      } else {
                        return;
                      }
                    })
                )
                .reduce((c, d) => c.concat(d), []),
        [[]]
    );

    return cartesian.filter((y) => y).map((x) => ({ qm: null, combin: x }));
  }

  private calcola_qm_quinella(element, lavagna, lavagnaSend: number, npartenti): number {
    const qa = this.calcolca_accoppiata(
        element[0].q / 100,
        element[1].q / 100,
        lavagna,
        lavagnaSend
    );
    const qb = this.calcolca_accoppiata(
        element[1].q / 100,
        element[0].q / 100,
        lavagna,
        lavagnaSend
    );

    return Math.round(1 / ( (1 / this.quotaVera(qa, lavagnaSend, npartenti)) + (1 / this.quotaVera(qb, lavagnaSend, npartenti)) ));
  }

  private calcolca_accoppiata(q1, q2, lavagna, lavagnaSend: number) {
    const num = q2 * (lavagna * q1 - 100);
    const den = 1;
    const acc = ((num / den) * lavagna) / lavagnaSend;
    return Math.round(acc);
    // return acc;
  }

  private quota_media(q1, q2) {
    const qm = (q1 * q2) / (q1 + q2);
    return Math.round(qm);
  }

  private calcola_qm_trio(element, lavagna, lavagnaSend: number, npartenti) {
    const qa = this.calcolca_trio(
        element[0].q / 100,
        element[1].q / 100,
        element[2].q / 100,
        lavagna,
        lavagnaSend
    );
    const qb = this.calcolca_trio(
        element[0].q / 100,
        element[2].q / 100,
        element[1].q / 100,
        lavagna,
        lavagnaSend
    );
    const qc = this.calcolca_trio(
        element[1].q / 100,
        element[0].q / 100,
        element[2].q / 100,
        lavagna,
        lavagnaSend
    );
    const qd = this.calcolca_trio(
        element[1].q / 100,
        element[2].q / 100,
        element[0].q / 100,
        lavagna,
        lavagnaSend
    );
    const qe = this.calcolca_trio(
        element[2].q / 100,
        element[0].q / 100,
        element[1].q / 100,
        lavagna,
        lavagnaSend
    );
    const qf = this.calcolca_trio(
        element[2].q / 100,
        element[1].q / 100,
        element[0].q / 100,
        lavagna,
        lavagnaSend
    );
    return Math.round(1 / (
        (1 / this.quotaVera(qa, lavagnaSend, npartenti)) +
        (1 / this.quotaVera(qb, lavagnaSend, npartenti)) +
        (1 / this.quotaVera(qc, lavagnaSend, npartenti)) +
        (1 / this.quotaVera(qd, lavagnaSend, npartenti)) +
        (1 / this.quotaVera(qe, lavagnaSend, npartenti)) +
        (1 / this.quotaVera(qf, lavagnaSend, npartenti))
    ));
  }

  private calcolca_trio(q1, q2, q3, lavagna, lavagnaSend: number) {
    const num =
        q3 *
        (lavagna * q1 - 100) *
        (lavagna * lavagna * q1 * q2 - 100 * lavagna * q1 - 100 * lavagna * q2);
    const den = 100 * lavagna * q1;
    const tro = ((num / den) * lavagna) / lavagnaSend;
    return Math.round(tro);
  }

  private calcola_q_tricast(element, lavagna, lavagnaSend) {
    return this.calcolca_trio(
        element[0].q / 100,
        element[1].q / 100,
        element[2].q / 100,
        lavagna,
        lavagnaSend
    );
  }

  private calcola_q_exacta(element, lavagna, lavagnaSend): number {
    return this.calcolca_accoppiata(element[0].q / 100, element[1].q / 100, lavagna, lavagnaSend);
  }

  private quotaVera(qe, lavagna, ncav): number {
    const num = qe;
    const den = lavagna + (ncav / 3) + 4.5 * Math.pow((qe / 100), 0.51);
    return Math.round(num / den * 100);
  }

  initAvvAndSisSistemi(sco: ISco[]): void {
    this.changeAvvSistema(sco);
    this.generateAndCountCombinations(this.cartBaseSistemi.sco);
  }

  changeAvvSistema(sco: ISco[]): void {
    // console.log(_.groupBy(sco, 'race'));

    // scommesse che non posso ragruppare per ia;
    const scommIaSeparate = [11, 14, 16, 18, 22, 23, 24];
    const scoGroup = _.groupBy(sco, 'race');
    const avvConst = [];
    sco.map((m) => {
      delete m.quotaMax;
      delete m.quotaMin;
    });
    sco.forEach((s) => {
      if (scoGroup[s.race].length > 1) {
        s.exclude = true;
        const codScomm = this.removeDuplicates(scoGroup[s.race].map((m) => m.cod));
        const scoObj = [];
        // console.log(sco);
        // console.log(s);

        // Questi controlli se ci sono le stesse quote così ne prendo una sola per generare il pagamento massimo e minimo
        // const quotaMaxAttuale = sco.filter((race) => race.race === s.race && race.cod === s.cod && s.ia === race.ia && race.quotaMax === true);
        // const quotaMinAttuale = sco.filter((race) => race.race === s.race && race.cod === s.cod && s.ia === race.ia && race.quotaMin === true);

        const quotaMaxAttuale = sco.filter((race) => race.race === s.race && race.quotaMax === true);
        const quotaMinAttuale = sco.filter((race) => race.race === s.race && race.quotaMin === true);

        // Controllo che ci sia gia una quota Max
        s.quotaMax = quotaMaxAttuale.length > 0 ? false : Math.max(...scoGroup[s.race].map((m) => Number(m.quo))) === Number(s.quo);

        // Controllo che ci sia già una quota min
        s.quotaMin = quotaMinAttuale.length > 0 ? false : Math.min(...scoGroup[s.race].map((m) => Number(m.quo))) === Number(s.quo);
        codScomm.forEach((cod: number) => {
          let scoObjTemp = {};
          if (scommIaSeparate.includes(cod)) {
            this.removeDuplicates(scoGroup[s.race].filter((race) => race.cod === cod).map((m) => m.ia)).forEach((ia) => {
              scoObjTemp = {
                cod: cod,
                ia: ia,
                esi: scoGroup[s.race].filter((race) => race.cod === cod && race.ia === ia).map((m) => { return {c: m.esi, q: m.quo, mv: false}; })
              };
              scoObj.push(scoObjTemp);
            });
          } else {
            scoObjTemp = {
              cod: cod,
              ia: scoGroup[s.race].filter((race) => race.cod === cod).map((m) => m.ia)[0],
              esi: scoGroup[s.race].filter((race) => race.cod === cod).map((m) => { return {c: m.esi, q: m.quo, mv: false}; })
            };
            scoObj.push(scoObjTemp);
          }
        });
        const obj = {
          race: s.race,
          fis: false,
          leg: 0,
          sco: scoObj
        };
        avvConst[s.race] = (obj);
      } else {
        s.exclude = false;
        const obj = {
          race: s.race,
          fis: false,
          leg: 0,
          sco: [{
            cod: s.cod,
            ia: s.ia,
            esi: [{
              c: s.esi,
              q: s.quo,
              mv: false
            }]
          }]
        };
        avvConst[s.race] = (obj);
        s.quotaMin = true;
        s.quotaMax = true;
      }
      s.fis = false;
    });
    // console.log(sco);
    this.cartBaseSistemi.sco = sco;
    this.cartBaseSistemi.avv = avvConst.filter(() => { return true; });
  }


  generateAndCountCombinations(arr): any {
    const combinations = [];
    const combinationCounts = [];
    const maxCombinationLength = arr.length; // Lunghezza massima delle combinazioni
    const fixedElements = arr.filter((el) => el.fis);

    // Inizializzare il contatore per ogni lunghezza
    for (let i = 1; i <= maxCombinationLength; i++) {
      combinationCounts[i] = {
        cod: i,
        imp: 0,
        mul: 0
      };
    }

    // Funzione ricorsiva per costruire combinazioni
    function combine(tempArr, start) {

      // Aggiungere la combinazione corrente al risultato e contare
      if (tempArr.length > 0) {
        combinations.push([...tempArr]);
      }

      // Generare combinazioni con i numeri rimanenti
      for (let i = start; i < (arr.length); i++) {
        tempArr.push(arr[i]);
        combine(tempArr, i + 1);
        tempArr.pop(); // Backtracking
      }
    }

    // Avviare la generazione delle combinazioni con un array vuoto e indice 0
    combine([], 0);

    // escludo le combinnazioni non possibili e quelle con fisse
    const combinationsFilter = [];
    combinations.forEach((comb) => {
      if ( !this.hasMultipleExclusions(comb)) {
        if (fixedElements.length === 0 || this.hasFixed(comb, fixedElements)) {
          combinationsFilter.push(comb);
        }
      }
    });

    combinationsFilter.forEach((comb) => {
      combinationCounts[comb.length] = {
        ...combinationCounts[comb.length],
        mul: combinationCounts[comb.length].mul + 1
      };
    });

    const group = _.groupBy(combinationsFilter, 'length');

    this.cartBaseSistemi.sis = combinationCounts.filter((c) =>  c.mul > 0 );
    this.cartBaseSistemi.comb = group;
  }

  hasFixed(combination, fixed) {
    const fixedExlude = fixed.filter((fix) => fix.exclude);
    const fixedNotExclude = fixed.filter((fix) => !fix.exclude);
    const setCombinatio = new Set(combination);

    // Se ci sono sia alementi fissi che esclusi che fissi non escludi
    // controllo che ci siano tutti i fissi non escludi + almeno uno di quelli fissi esclusi
    if ( fixedExlude.length > 0 && fixedNotExclude.length > 0) {
      return fixedNotExclude.every((comb) => setCombinatio.has(comb)) && fixedExlude.some((comb) => setCombinatio.has(comb));
    }
    // Se ci sono sia alementi fissi che esclusi senza i fissi non escludi
    // almeno uno di quelli fissi esclusi
    if ( fixedExlude.length > 0 && fixedNotExclude.length === 0) {
      return fixedExlude.some((comb) => setCombinatio.has(comb));
    }
    return fixedNotExclude.every((comb) => setCombinatio.has(comb));
  }

  // Funzione per verificare se una combinazione include più di un elemento 'exclude' AND non è una multipla OR non ci sono testa a testa contro
  hasMultipleExclusions(combination) {
    const excludeCount = combination.filter((el) => {
      // return el.exclude && (!el.multipla || (el.multipla && combination.filter((e) => e.race === el.race && e.cod !== 11).length > 0) || this.countDuplicates(combination.filter((e) => e.cod === 11).map((i) => i.ia + '-' + i.race)));
      return el.exclude;
    }).map((m) => m.race);
    return this.countDuplicates(excludeCount) > 0 || (combination.filter((f) => f.extra.antepost === '1').length > 0 && combination.filter((f) => f.extra.antepost === '1').length !== combination.length);
  }

  getMinPagComb(comb) {
    return Math.min(...this.cartBaseSistemi.comb.pagMin[comb]);
  }
  getMaxPagComb(comb) {
    // return Math.max(...this.cartService.cartBaseSistemi.comb.pag[comb]);
    let pagMax = 0;
    this.cartBaseSistemi.comb.pag[comb].forEach((pag) => {
      pagMax = pagMax + pag;
    });
    return pagMax;
  }

  getSummary() {
    this.cartBaseSistemi.pagMax = 0;
    this.cartBaseSistemi.pagmin = 0;
    this.cartBaseSistemi.pun = 0;
    const allMinWin = [];
    this.cartBaseSistemi.sis.forEach((sis) => {
      if (sis.imp > 0) {
        this.cartBaseSistemi.pun = this.cartBaseSistemi.pun + (sis.imp * sis.mul);
        this.cartBaseSistemi.pagMax = this.cartBaseSistemi.pagMax + this.getMaxPagComb(sis.cod);
        allMinWin.push(Math.min(...this.cartBaseSistemi.comb.pagMin[sis.cod]));
      }
    });
    if (allMinWin.length  > 0) {
      this.cartBaseSistemi.pagmin = Math.min(...allMinWin);
    }
  }

  // Funzione per verificare i duplicati
  countDuplicates(original) {
    const uniqueItems = new Set();
    const duplicates = new Set();
    const array = [];
    for (const value of original) {
      if (uniqueItems.has(value)) {
        duplicates.add(value);
        uniqueItems.delete(value);
      } else {
        uniqueItems.add(value);
      }
    }
    return duplicates.size;
  }


  removeDuplicates(array) {
    const mySet = new Set(array);
    return  [...mySet];
  }

}
